import Layout from "@/views/layout";

const subordinate = {
  path: "/subordinate",
  name: "subordinate",
  component: Layout,
  meta: { title: "合作伙伴" },
  children: [
    {
      path: "StoreSdata",
      name: "storesdata",
      component: () => import("@/views/subordinate/storesdata"),
      meta: { title: "合作伙伴资料" }
    },
    {
      path: "storestheditor",
      name: "storestheditor",
      component: () => import("@/views/subordinate/storestheditor"),
      meta: { title: "合作伙伴编辑" }
    },
  ]
};

export default subordinate;
